// extracted by mini-css-extract-plugin
module.exports = {"image":"SmallImageWithAside-module--image--16Hit","content":"SmallImageWithAside-module--content--3exYh"};